import { RootState } from "../../store";

export const selectUser = (state: RootState) => state.user;
export const selectBlogger = (state: RootState) => state.blogger;
export const selectIsAuthenticated = (state: RootState) => state.user.authenticated;
export const selectAssetsFolder = (state: RootState) => selectBlogger(state).assetsFolder;
export const selectBlogMode = (state: RootState) => state.blogger?.mode;

